module.exports = __webpack_public_path__ + "img/selected3-min.0823b09a.png";